import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './en/translation.json';
import translationBA from './bs/translation.json';
import LanguageDetector from 'i18next-browser-languagedetector';

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'aliasedNavigator',
  lookup(options) {
    if (typeof navigator === 'undefined') return undefined;
    
    const languages = navigator.languages || [navigator.language || navigator.userLanguage || ''];
    
    for (let i = 0; i < languages.length; i++) {
        if (!languages[i]) continue;
        const langCode = languages[i].split('-')[0].toLowerCase();
        // If the browser language is Croatian, Serbian, or Slovenian, return 'bs'
        if (langCode === 'hr' || langCode === 'sr' || langCode === 'sl') { 
            return 'bs';
        }
        return languages[i];
    }
    return undefined;
  }
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      bs: { translation: translationBA },
    },
    supportedLngs: ['en', 'bs'],
    fallbackLng: 'en', // default jezik
    detection: {
      order: ['localStorage', 'cookie', 'aliasedNavigator'],
      caches: ['localStorage'], // sprema korisnikov izbor
      lookupLocalStorage: 'i18nextLng', // key u localStorage
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
